<script>

export default {
  data() {
    return {
      loading: true,
      cur_month: '',
      items: [],
      filters: {
        page: 1,
        paginate: 7,
        total: 0,
        selects: ['id','view_count','title'],
        wheres: {
          status: 1,
        },
        whereins: {
          website: [],
        },
        orderbys: {
          view_count: 'DESC',
        },
      },
    }
  },
  created() {
    this.filters.whereins.website = [this.website_id];
    this.cur_month = this.moment();
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/blogs/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.items = res.data.data;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div class="card-box p-0 position-relative" id="print-blogs_view_chart">
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="p-3">
      <div class="float-right">
        <div class="form-inline">
          <button type="button" class="btn btn-light ml-2 print_target" target="print-blogs_view_chart" v-tippy title="Print"><Icon icon="ri:printer-line" /></button>
          <w-field class="ml-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="fetchData()" :Disabled="loading"></w-field>
        </div>
      </div>
      <h4 class="header-title"><Icon icon="ri:newspaper-line" /> Blog articles</h4>
      <p class="m-0 small">Top {{filters.paginate}} most viewed Blog articles</p>
    </div>
    <div class="table-responsive m-0">
      <table class="table table-bordered-right table-hover mb-0 table-centered small">
        <tbody>
          <router-link v-for="(item, index) in items" :key="item.id" :to="'/blogs/'+item.id" tag="tr" class="_c-pointer" exact v-tippy content="Click to open this Blog article">
            <td><router-link :to="'/blogs/'+item.id" class="text-secondary"><Icon icon="ri:external-link-line" /> {{item.title}}</router-link></td>
            <td class="_w-80 text-center"><router-link :to="'/blogs/'+item.id" class="text-secondary">{{item.view_count}}</router-link></td>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>
